import type { User } from '@/api/auth';
import {
  promoRestrictedGroups,
  someGroupMember,
  type USER_GROUP,
} from '@/helpers/user';

export const checkIsCmsPromoAvailable = (
  isAvailableByDate?: boolean,
  user?: User,
  restrictedGroups?: USER_GROUP[],
  countryCode?: string,
  allowedCountries?: string[]
) => {
  if (!isAvailableByDate) return false;

  if (
    allowedCountries?.length &&
    countryCode &&
    !allowedCountries.includes(countryCode)
  )
    return false;

  const groups = restrictedGroups ?? promoRestrictedGroups;
  return !someGroupMember(groups)(user);
};
